<script setup lang="ts">
import { DiscreteNumericListDto } from '@/api/generator';
import DiscreteNumericList from '@/components/forms/dataTypes/DiscreteNumericList.vue';
import type { VeeDiscreteNumericListProps } from '@/components/forms/types.ts';
import { toRef } from 'vue';
import { useField } from 'vee-validate';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeDiscreteNumericListProps>();

const veeProps = useVeeFormProps(props);

const { errorMessage, value, meta, handleChange, handleBlur } = useField<DiscreteNumericListDto>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: true,
  },
);

function onUpdate(input: DiscreteNumericListDto | undefined) {
  handleChange(input, meta.touched);
}

function onBlur(event: FocusEvent) {
  handleBlur(event, true);
}
</script>

<template>
  <DiscreteNumericList
    v-bind="veeProps"
    :errorMessage="errorMessage"
    :discreteNumericList="value"
    @blur="onBlur"
    @update:discreteNumericList="onUpdate"
  />
</template>
